import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import { AddBrandComponent } from '../../mnt-products/add-brand/add-brand.component';
import { FlashMessagesService } from "angular2-flash-messages";

@Component({
  selector: 'app-edit-quick-item',
  templateUrl: './edit-quick-item.component.html',
  styleUrls: ['./edit-quick-item.component.css']
})
export class EditQuickItemComponent implements OnInit {

  public loading = false;
  quickItemForm: FormGroup;
  public activeProjectIndex = "";
  public quickItemIndex = 0;
  public projects: any = {};
  public orderStatus: string;
  public quickItemSizes = [];
  public isPublicQuoteCreation = false;
  public productStyleImage = null;
  public productStyleSelectedFile = null;
  public filters: any = {};
  public brands: any = {};
  public colors: any = {};
  public sizes: any = {};
  public matrixes: any = {};
  public providerList: any[] = [];
  public supplierList = [];
  colorControl = new FormControl('');
  showDropdown = false;
  filteredColors: any[] = [];
  productId: string = '';
  productData: any = {};
  activeClass: string = '';

  constructor(private commonService: CommonService,
      private formBuilder: FormBuilder,
      private CommonProjectDataService: CommonProjectDataService,
      private dialog: MatDialog,
      private router: Router,
      private route: ActivatedRoute,
      private _flashMessagesService: FlashMessagesService,
    ) {
      this.quickItemForm = this.formBuilder.group({
        brand: [null, Validators.required],
        name: [null, Validators.required],
        description: [''],
        color: [null, Validators.required],
        size: [null, Validators.required],
        price: [null, [Validators.required, Validators.min(0)]], 
        supplier: [null, Validators.required],
      });
      this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    }

  ngOnInit() {
    this.getQuickItemAttributes(['sizes', 'brands', 'colors', 'matrixes']);
  
    this.route.params.subscribe(params => {
      this.productId = params['productId'] || '';
  
      if (this.productId) {
        this.getProductData();
      }
    });
  }
    

  isFieldValid(field: string) {
    return (
      !this.quickItemForm.get(field).valid &&
      this.quickItemForm.get(field).touched
    );
  }

  getProductData = function () {
    this.loading = true;
    this.options = {
      id: localStorage.getItem("userID"),
      product_id: this.productId
    }
    this.commonService.apiService(
      "POST",
      "quickItem/edit",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.productData = response.data;

            this.quickItemForm.patchValue({
              brand: this.productData.brand,
              name: this.productData.name,
              description: this.productData.description,
              size: this.productData.size,
              color: this.productData.color,
              price: this.productData.price,
              supplier: this.productData.supplier,
            });
      
            // Set product image if available
            if (this.productData.image) {
              this.productStyleImage = this.productData.image;
            }
      
            this.colorControl.setValue(this.productData.color);
            this.activeClass = 'active';
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  getQuickItemAttributes = function (attributes) {
    this.loading = true;
    this.options = {
      id: localStorage.getItem("userID"),
      attributes: attributes
    }
    this.commonService.apiService(
      "POST",
      "quickItem/attributes",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.brands = response.data.brands ? response.data.brands : this.brands;
            this.sizes = response.data.sizes ? response.data.sizes : this.sizes;
            this.colors = response.data.colors ? response.data.colors : this.colors;
            this.matrixes = response.data.matrixes ? response.data.matrixes : this.matrixes;

            this.filters.brands = this.brands;
            this.filters.sizes = this.sizes;
            this.filters.colors = this.colors;
            this.filters.matrixes = this.matrixes;

            if (this.filters.matrixes && Object.keys(this.filters.matrixes).length > 0) {
              this.providerList = Object.keys(this.filters.matrixes).map(key => ({
                providerName: key,
                matrixes: this.filters.matrixes[key]
              }));
            }
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  submitQuickItem = function (postData) {
    if (this.quickItemForm.invalid) return;
    this.loading = true;

    const formData = new FormData();
    Object.keys(postData).forEach(key => {
      formData.append(key, postData[key]);
    });

    if (this.productStyleSelectedFile != null) {
      formData.append('image', this.productStyleSelectedFile, this.productStyleSelectedFile.name);
    }

    formData.append('id', localStorage.getItem("userID"));
    formData.append('product_id', this.productId);

    this.commonService.apiService(
      "POST",
      "quickItem/update",
      formData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this._flashMessagesService.show("Quick Item updated successfully!", {
              cssClass: "alert-success",
              timeout: 5000
            });
          }
        }        
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  }

  onStyleFileChanged(event) {
    this.productStyleSelectedFile = event.target.files[0];
    var render = new FileReader();
    render.onload = (event: any) => {
      this.productStyleImage = event.target.result;

    }
    render.readAsDataURL(this.productStyleSelectedFile);
  }

  titleCase(str: string): string {
    if (!str) return '';
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }

  openBrandDialog(): void {
    const dialogRef = this.dialog.open(AddBrandComponent, {
      width: "250px",
      data: { provider: 'quickItem' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getQuickItemAttributes(['brands']);
      }
    });
  }

  filterColors() {
    const search = this.colorControl.value ? this.colorControl.value.toLowerCase() : '';
    if (search) {
      this.filteredColors = this.filters.colors.filter(color =>
        color.name.toLowerCase().includes(search)
      );
      this.quickItemForm.get('color').setValue(search);
      this.showDropdown = this.filteredColors.length > 0;
    } else {
      this.filteredColors = [];
      this.showDropdown = false;
    }
  }

  selectColor(color: any) {
    this.colorControl.setValue(color.name);
    this.quickItemForm.get('color').setValue(color.name);
    this.filteredColors = [];
    this.showDropdown = false;
  }

  hideDropdown() {
    setTimeout(() => {
      this.showDropdown = false;
      this.filteredColors = [];
    }, 200);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/edit-quick-item/edit-quick-item.component.ts